import React from 'react';
import { usePageTracking } from '../lib/analytics';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  usePageTracking();
  return <>{children}</>;
};
